import { Box, Container, Typography, Button } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

export function NotFoundPage() {
  return (
    <Container maxWidth="sm">
      <Box component="main" sx={{ py: 12, textAlign: 'center' }}>
        <Typography component="h1" variant="h3" gutterBottom>
          404
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
          Page introuvable.
        </Typography>
        <Button component={RouterLink} to="/" variant="contained">
          Retour à l&apos;accueil
        </Button>
      </Box>
    </Container>
  );
}
